// extracted by mini-css-extract-plugin
module.exports = {"checkbox":"CheckboxWidget_checkbox__HfJfI","label":"CheckboxWidget_label__3ovud"};